import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "layout-topbar" }
const _hoisted_2 = { class: "layout-topbar-menu hidden lg:flex origin-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: "layout-topbar-logo"
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
        _createElementVNode("span", { class: "header-app-title" }, "COMPASS DB", -1)
      ]))]),
      _: 1
    }),
    (this.$store.getters.isInternalUser)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "p-link layout-menu-button layout-topbar-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMenuToggle && _ctx.onMenuToggle(...args)))
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "pi pi-bars" }, null, -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "p-link layout-topbar-menu-button layout-topbar-button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSettingsToggle && _ctx.onSettingsToggle(...args)))
    }, [...(_cache[6] || (_cache[6] = [
      _createElementVNode("i", { class: "pi pi-ellipsis-v" }, null, -1)
    ]))]),
    _createElementVNode("ul", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("li", { class: "hidden" }, [
        _createElementVNode("button", { class: "p-link layout-topbar-button" }, [
          _createElementVNode("i", { class: "pi pi-calendar" }),
          _createElementVNode("span", null, "Events")
        ])
      ], -1)),
      _createElementVNode("li", null, [
        _createVNode(_component_Menu, {
          ref: "settings",
          model: _ctx.settingsMenuItems,
          popup: true
        }, null, 8, ["model"]),
        _createElementVNode("button", {
          class: "p-link layout-topbar-button",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onSettingsToggle && _ctx.onSettingsToggle(...args)))
        }, [...(_cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "pi pi-cog" }, null, -1),
          _createElementVNode("span", null, "Settings", -1)
        ]))])
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_Menu, {
          ref: "profile",
          model: _ctx.profileMenuItems,
          popup: true,
          style: {"width":"auto"},
          class: "mr-2"
        }, null, 8, ["model"]),
        _createElementVNode("button", {
          class: "p-link layout-topbar-button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onProfileToggle && _ctx.onProfileToggle(...args)))
        }, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("i", { class: "pi pi-user" }, null, -1),
          _createElementVNode("span", null, "Profile", -1)
        ]))])
      ])
    ])
  ]))
}